import * as linkConst from '../../../constants/link_constants'
import * as defaultConst from '../../../constants/default_constants'
import Moment from 'moment'
import Validators from '../validators'
import { extendMoment } from 'moment-range'
const moment = extendMoment(Moment)

export default (store) => store.createEmbededEntityState({
  lastSave: 'flyprivate_video_pricing',
  attrs: [
    'control', 'id', 'platform', 'type_sale', 'tier',
    'valid_from', 'valid_to', 'utc_flag', 'regions',
    'quality_mobile', 'quality_sd', 'quality_hd',
    'quality_uhd', 'coming_soon_flag', 'prior_flag'
  ],
  titles: [
    '', store.__('ID'), store.__('Platform'), store.__('Type sale'), store.__('Tier'),
    store.__('Valid from'), store.__('Valid to'), store.__('UTC time'),
    store.__('Regions'), store.__('Mobile quality'), store.__('SD quality'),
    store.__('HD quality'), store.__('UHD quality'), store.__('Coming soon'), store.__('Prior item')
  ],
  timeRestriction: 'flyprivate_video_pricing',
  _sortDir: 'ASC,ASC,ASC,ASC,ASC,ASC',
  _sortField: 'platform,type_sale,regions,valid_from,valid_to',
  noSort: ['control'],
  initVals: (row) => ({
    prior_flag: 1,
    control_timestamp: Math.round(new Date().getTime())
  }),
  validators: {
    regions: [
      Validators.isMandatory(store),
      Validators.regionTest(store)
    ],
    valid_from: [
      Validators.isValidFromTo(store),
      Validators.isMandatoryDate(store)
    ],
    valid_to: [
      Validators.isValidFromTo(store),
      Validators.isMandatoryDate(store)
    ],
    _global: (vals, values, batch = false) => {
      if (!vals.has) {
        vals.has = (k) => vals[k] || false
        vals.get = (k) => vals[k] || null
        vals.set = (k, v) => { vals[k] = v }
      }

      // only one pricing for batch: BATCH_ACTION_PRICING_TEMP
      if (store.router.params &&
        store.router.params.operation === linkConst.BATCH_ACTION_PRICING_TEMP &&
        !batch
      ) {
        if (values && values.length > 0 &&
          vals.has('control_timestamp') &&
          vals.get('control_timestamp') !== values[0].control_timestamp) {
          return [store.__('Selected "pricing" must be only one.')]
        } else if (vals.has('valid_from') &&
          moment(vals.get('valid_from')).isSame(moment())) {
          return [store.__('"Valid from" date must be after today.')]
        } else if (vals.has('valid_to') &&
          moment(vals.get('valid_to')).isSame(moment())) {
          return [store.__('"Valid to" date must be after today.')]
        }
      }

      const temporary = batch
        ? new Map()
        : store.cv.temporary
      const flyprivatePricingTier = vals.has('flyprivate_platform_tier_pricing_id') &&
        vals.get('flyprivate_platform_tier_pricing_id')
        ? store.options.get('flyprivate_pricings')
          .find(i => i.id === vals.get('flyprivate_platform_tier_pricing_id'))
        : null
      if (temporary &&
        !temporary.has('pricing_select_tier') &&
        flyprivatePricingTier) {
        temporary.set('pricing_select_type', flyprivatePricingTier.type_sale)
        temporary.set('pricing_select_tier', flyprivatePricingTier.tier)
        temporary.set('pricing_select_platform', flyprivatePricingTier.platform)
      }

      // remove prices if coming soon is set
      const isCommingSoon = vals &&
        vals.has('coming_soon_flag') &&
        vals.get('coming_soon_flag')
      if (isCommingSoon) {
        vals.set('quality_hd', false)
        vals.set('quality_mobile', false)
        vals.set('quality_sd', false)
        vals.set('quality_uhd', false)
      }

      // pricing tier filters - selectors
      if (temporary &&
        (!temporary.has('pricing_select_platform') || !temporary.get('pricing_select_platform'))) {
        temporary.set('pricing_select_type', '')
        temporary.set('pricing_select_tier', '')
        vals.set('flyprivate_platform_tier_pricing_id', null)
      }
      if (temporary &&
        (!temporary.has('pricing_select_type') || !temporary.get('pricing_select_type'))) {
        temporary.set('pricing_select_tier', '')
        vals.set('flyprivate_platform_tier_pricing_id', null)
      }
      if (temporary &&
        (!temporary.has('pricing_select_tier') || !temporary.get('pricing_select_tier'))) {
        vals.set('flyprivate_platform_tier_pricing_id', null)
      }

      // finaly set flyprivate_platform_tier_pricing_id if all parametrs are selected
      if (flyprivatePricingTier || (temporary &&
        temporary.has('pricing_select_platform') && temporary.get('pricing_select_platform') &&
        temporary.has('pricing_select_tier') && temporary.get('pricing_select_tier') &&
        temporary.has('pricing_select_type') && temporary.get('pricing_select_type'))
      ) {
        const found = store.options.get('flyprivate_pricings')
          .find(i =>
            i.platform === temporary.get('pricing_select_platform') &&
          i.type_sale === temporary.get('pricing_select_type') &&
          i.tier === temporary.get('pricing_select_tier')
          )
        vals.set('flyprivate_platform_tier_pricing_id', found
          ? found.id
          : null)
        if (found) {
          temporary.set('pricing_select_platform', found.platform)
          temporary.set('pricing_select_tier', found.tier)
          temporary.set('pricing_select_type', found.type_sale)
        }
      }

      // exception - global Pricing ID validation
      if (!vals.has('flyprivate_platform_tier_pricing_id') ||
        !vals.get('flyprivate_platform_tier_pricing_id')) {
        return store.__('Pricing ID is mandatory')
      }

      const error = []
      const countries = store.options.get('Countries')
      const getRegions = (regions) => {
        if (!regions || !regions.length) {
          return ['']
        } else if (regions === 'WW') {
          return ['WW']
        }
        const splitRegions = (regions.charAt(0) === '-' ? regions.substring(1) : regions).split(',')
        return regions.charAt(0) === '-'
          ? countries.map(country => !splitRegions
            .find(region => region === country.value) && country.value)
            .filter(result => result && result.length <= 2)
          : splitRegions
      }
      const regions = vals.get('regions') && vals.get('regions').length > 0 ? getRegions(vals.get('regions')) : ['']
      const noOverlap = ['EST', 'TVOD']
      const svodOverlap = ['SVOD', 'AVOD']
      const getItem = id => store.options.get('flyprivate_pricings').find(p => p.id === id)

      // test again existing values
      values && values.forEach(v => {
        const vPricing = getItem(v.flyprivate_platform_tier_pricing_id)
        const vPlatform = vPricing.platform
        const vTypeSale = vPricing.type_sale
        const vRegionsAll = getRegions(v.regions)
        const utcFlag1 = (vals.has('utc_flag') && vals.get('utc_flag') &&
          (vals.get('utc_flag') > 0 || vals.get('utc_flag') === 'true' || vals.get('utc_flag') === true)) || false
        const utcFlag2 = (v.utc_flag && (v.utc_flag > 0 || v.utc_flag === 'true' || v.utc_flag === true)) || false

        if (((typeof v.id === 'undefined' && vals.has('id')) ||
           (v.id && v.id !== vals.get('id')) ||
           (v.control_timestamp && vals.has('control_timestamp') &&
            v.control_timestamp !== vals.get('control_timestamp'))
        ) &&
          vals.get('flyprivate_platform_tier_pricing_id') === v.flyprivate_platform_tier_pricing_id &&
          !moment(vals.get('valid_to')).isBefore(moment()) &&
          !moment(v.valid_to).isBefore(moment()) &&
          (svodOverlap.includes(vTypeSale) || (
            (noOverlap.includes(vTypeSale) ||
            (noOverlap.includes(temporary.get('pricing_select_type')) &&
              noOverlap.some(typeSale =>
                vTypeSale === typeSale && temporary.get('pricing_select_type') === vPlatform))) &&
            vTypeSale === temporary.get('pricing_select_type'))
          ) &&
          vRegionsAll.some(region => regions.includes(region) &&
            Validators._datesOverlapping(
              vals.get('valid_from'), vals.get('valid_to'), v.valid_from, v.valid_to,
              region,
              utcFlag1,
              utcFlag2,
              store
            )
          )

        ) {
          error.push(
            vTypeSale + ' ' +
            store.__('can\'t overlap. The collision items are: ') +
            (vals.has('id') ? (' ID ' + vals.get('id')) : store.__(' new item ')) +
            store.__(' & ') +
            (v.id ? ' ID ' + v.id : store.__(' new item ')) + store.__(' (regions: ') +
            vRegionsAll.filter(r => regions.includes(r)).join(', ') + '). ' + ' '
          )
        }

        // if same tier_pricing_id, regions, prior_flag and dates return error
        if (((typeof v.id === 'undefined' && vals.has('id')) ||
          (v.id && v.id !== vals.get('id')) ||
          (v.control_timestamp && vals.has('control_timestamp') &&
            v.control_timestamp !== vals.get('control_timestamp'))) &&
          vals.get('flyprivate_platform_tier_pricing_id') === v.flyprivate_platform_tier_pricing_id &&
          moment([...Validators._dateFromDate(vals.get('valid_from'))]).isSame(moment([...Validators._dateFromDate(v.valid_from)])) &&
          moment([...Validators._dateFromDate(vals.get('valid_to'))]).isSame(moment([...Validators._dateFromDate(v.valid_to)])) &&
          utcFlag1 === utcFlag2 &&
          (parseInt(vals.get('prior_flag')) === parseInt(v.prior_flag) ||
          (vals.get('prior_flag') === true && parseInt(v.prior_flag) === 1) ||
          (vals.get('prior_flag') === false && parseInt(v.prior_flag) === 0)) &&
          vals.get('regions') === v.regions) {
          // return validation error
          error.push(store.__('Pricing must be unique. There is a collision with the pricing: ') +
            (v.id || store.__('new')))
        }
      })

      // choose at least one quality
      const hd = vals.get('quality_hd')
      const mobi = vals.get('quality_mobile')
      const sd = vals.get('quality_sd')
      const uhd = vals.get('quality_uhd')
      if (!(mobi || sd || hd || uhd) && !isCommingSoon) {
        error.push(store.__(' Check at least one quality, please. '))
      }

      return error.length > 0
        ? error
        : undefined
    }
  }
})
